module.exports = __webpack_public_path__ + "img/map-pin-point.2affc380.png";